import { Grid, Typography, Button , Card} from '@mui/material'
import { ReactComponent as MyProfileIcon} from '../../../icons/teDhenatIcon.svg';
import colors from '../../colors';
import React from 'react'
import {useDispatch, useSelector } from 'react-redux';
import { setAreEmailNotificationsSuccessfullySet, selectUserInfo, setAreNotificationsFetched } from '../../../features/userInfo/userInfoSlice';
import { sendGeneralRequest } from '../../../features/generalRequest';
import { selectGlobalDataState, setGeneralMessage } from '../../../features/global/globalDataSlice';
import Switch from '@mui/material/Switch';
import Lottie from "lottie-react";
import smallLoadingAnimation from '../../../icons/lottieAnimations/smallLoading.json'
import { makeStyles } from '@mui/styles';
import { texts } from '../../general/texts';

export const Notifications = () => {

  const dispatch = useDispatch()
  const userInfo = useSelector(selectUserInfo)
  const globalDataSliceState = useSelector(selectGlobalDataState)

  const [isChecked, setIsChecked] = React.useState(false)

  const handleSwitchChange = (event) => {
    setIsChecked(event.target.checked)
  }

  const handleButtonClick = () => 
  { 
    dispatch(sendGeneralRequest(
      {
        request: {
          notifications: userInfo.notifications.map(notification => {
            return {emailActive: isChecked, name:notification.name, smsActive:true}
          }),
          pushActive:true,       
          token: globalDataSliceState.token}, 
          baseUrlKey: 'services', 
          endpoint:'SetNotificationsPerAllServices'
        }))

    dispatch(setAreNotificationsFetched(false))      
  }

  React.useEffect(() => {
      if(userInfo.areEmailNotificationsSuccessfullySet)
      {
        dispatch(setGeneralMessage({type: 'success', message: texts["message-notification-change-successfull"]}))
        dispatch(setAreEmailNotificationsSuccessfullySet(false))
      }
  }, [userInfo.areEmailNotificationsSuccessfullySet])

  React.useEffect(()=>{
    if(userInfo.areNotificationsFetched === false)
    {
      dispatch(sendGeneralRequest({request: {token: globalDataSliceState.token}, baseUrlKey: 'services', endpoint:'GetServicesNotifications'}))
      dispatch(setAreNotificationsFetched(true))
    }
    setIsChecked(userInfo.areEmailNotificationsActive)
  },[userInfo.areEmailNotificationsActive])

  const useStyles = makeStyles({
    card:{
      width:'50%',
      borderRadius:'20px',
      boxShadow:'0 0 15px 5px #E5E7EA',
      '@media (max-width: 899px)' : {width:'90%'}
    },
    iconBox:{
      background:colors.cyan,
      borderRadius:'15px',
      width:'60px',
      height:'60px',
      marginLeft:'3%'
    },
    cardTitle:{
      color: colors.darkBlue,
      fontSize:'1.5rem',
      fontFamily:'GerberaBold',
      paddingTop:'1%',
      paddingLeft:'2%'
    },
    text:{
      color:colors.darkBlue,
      fontSize:'1rem',
      textAlign:'left',
      fontFamily:'GerberaLight'
    },
    button:{
      
      color:colors.white,
      background:colors.gradientOrange,
      borderRadius:'5px',
      fontSize:'0.9rem',
      fontFamily:'GerberaBold',
      textTransform:'none',
      width:'200px'
    }
  })

  const classes = useStyles()
    
  return (
    <Grid container item justifyContent={'center'} pt={'3%'}>
      <Card className={classes.card} >
        <Grid container item md={12} rowSpacing={8} pt={'5%'}  >
          <Grid container item rowSpacing={2}>
              <Grid container  direction="column" justifyContent="center" alignItems="center" className={classes.iconBox} ><MyProfileIcon/></Grid>
              <Typography className={classes.cardTitle} >{texts["placeholder-notification"]}</Typography>     
          </Grid>
          <Grid container item  rowSpacing={2} pl={'3%'} pb={'20%'}>
            <Grid container item >
              <Grid item md={10} xs={8}>
                  <Typography className={classes.text} >{texts["title-email-notifications"]}</Typography>
              </Grid>
              <Grid item md={2} xs={4}>
                  <Switch id='emailActive' checked={isChecked} onChange={handleSwitchChange} color='warning' />
              </Grid>
            </Grid>
          </Grid>
          <Grid container item md={12} xs={12} justifyContent={'center'} pb={'3%'} >
            <Button onClick={handleButtonClick} disabled={userInfo.isLoading ? true : false} className={classes.button} >
                {texts["title-favorite-save-short"]}
            </Button>
          </Grid>
          <Grid container justifyContent={'center'} >
            <Grid container item md={1} xs={1} >
                {userInfo.isLoading && <Lottie animationData={smallLoadingAnimation} loop={true} autoplay={true}/>}    
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </Grid>
  )
}
export default Notifications